import React, {VoidFunctionComponent} from 'react';

import SVGIcon, {SVGIconProps} from '../svg-icon/svg-icon';

export enum FullscreenIconVariant {
  MAXIMIZE = 'maximize',
  MINIMIZE = 'minimize'
}

interface Props extends SVGIconProps {
  variant: 'maximize' | 'minimize';
}

const FullscreenIcon: VoidFunctionComponent<Props> = props => {
  const {variant, ...svgProps} = props;
  const rotation = variant === FullscreenIconVariant.MINIMIZE ? 180 : 0;

  return (
    <SVGIcon {...svgProps}>
      <path
        d="M3 9V5C3 3.9 3.9 3 5 3H9V5H5V9H3Z"
        fill="currentColor"
        transform={`rotate(${rotation}, 6, 6)`}
      />
      <path
        d="M3 15H5V19H9V21H5C3.9 21 3 20.1 3 19V15Z"
        fill="currentColor"
        transform={`rotate(${rotation}, 6, 18)`}
      />
      <path
        d="M19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19Z"
        fill="currentColor"
        transform={`rotate(${rotation}, 18, 18)`}
      />
      <path
        d="M15 3H19C20.1 3 21 3.9 21 5V9H19V5H15V3Z"
        fill="currentColor"
        transform={`rotate(${rotation}, 18, 6)`}
      />
    </SVGIcon>
  );
};

export default FullscreenIcon;
